export default __webpack_public_path__ + "static/media/1763.cfa65ae3.png";